var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar-queue',{staticClass:"snack-bar",attrs:{"items":_vm.items,"timeout":2000,"closeButtonIcon":"mdi-close","nextButtonCountText":"+","nextButtonText":""},on:{"remove":_vm.removeItem}})}
var staticRenderFns = []

export { render, staticRenderFns }